import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Componentes de rutas
import { LoginComponent } from './Shared/Pages/login/login.component';
import { NotFoundComponent } from './Shared/Pages/not-found/not-found.component';

// Guardias
import { AuthenticationGuard } from './Shared/Guards/authentication.guard';
import { LoggedGuard } from './Shared/Guards/logged.guard';
import { isPasswordGuard } from './Shared/Guards/restorePassword.guard';
import { AuthorizedGuard } from './Shared/Guards/authorized.guard';
import { RequestRestorePasswordComponent } from './Shared/Pages/request-restore-password/request-restore-password.component';
import { RestorePasswordComponent } from './Shared/Pages/restore-password/restore-password.component';
import { UserType, UserPage } from './Shared/Services/authenticator.service';
import { LoadingRestorePasswordComponent } from './Shared/Pages/loading-restore-password/loading-restore-password.component';
import { LoadingValidateCorreoComponent } from './Shared/Pages/loading-validate-correo/loading-validate-correo.component';

import { isValidateCorreoGuard } from './Shared/Guards/validateCorreo.guard';
import { ValidateCorreoComponent } from './Shared/Pages/validate-correo/validate-correo.component';

const routes: Routes = [
    {   path: '/',
        redirectTo: 'login',
        pathMatch: 'full',
    },
    {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
    },
    {
        path: 'login',
        component: LoginComponent,
        canLoad: [LoggedGuard],
        canActivate: [LoggedGuard],
    },
    {
        path: 'loading-restore-password',
        component: LoadingRestorePasswordComponent,
        canLoad: [LoggedGuard],
        canActivate: [LoggedGuard],
    },
    {
        path: 'restore-password',
        component: RestorePasswordComponent,
        canLoad: [LoggedGuard, isPasswordGuard],
        canActivate: [LoggedGuard, isPasswordGuard],
    },
    {
        path: 'loading-validate-correo',
        component: LoadingValidateCorreoComponent,
    },
    {
        path: 'validate-correo',
        component: ValidateCorreoComponent,
        canLoad: [isValidateCorreoGuard],
        canActivate: [isValidateCorreoGuard],
    },
    {
        path: 'qr',
        component: LoginComponent,
        canLoad: [AuthenticationGuard],
        canActivate: [AuthenticationGuard],
    },
    {
        path: UserPage.Administrador,
        loadChildren: () =>
            import('./Admin/admin.module').then((m) => m.AdminModule),
        canLoad: [AuthorizedGuard],
        canActivate: [AuthorizedGuard],
        data: { expectedRole: UserType.Administrador },
    },
    {
        path: UserPage.Alumno,
        loadChildren: () =>
            import('./Alumno/alumnos.module').then((m) => m.AlumnosModule),
        canLoad: [AuthorizedGuard],
        canActivate: [AuthorizedGuard],
        data: { expectedRole: UserType.Alumno },
    },
    {
        path: UserPage.GestionAcademica,
        loadChildren: () =>
            import('./DA/departamentos-academicos.module').then(
                (m) => m.GestionAcademicaModule
            ),
        canLoad: [AuthorizedGuard],
        canActivate: [AuthorizedGuard],
        data: { expectedRole: UserType.GestionAcademica },
    },
    {
        path: UserPage.DesarrolloAcademico,
        loadChildren: () =>
            import('./DAC/desarrollo-academico.module').then(
                (m) => m.DesarrolloAcademicoModule
            ),
        canLoad: [AuthorizedGuard],
        canActivate: [AuthorizedGuard],
        data: { expectedRole: UserType.DesarrolloAcademico },
    },
    {
        path: UserPage.CoordinacionCarreras,
        loadChildren: () =>
            import('./DEP/estudios-profesionales.module').then(
                (m) => m.EstudiosProfesionalesModule
            ),
        canLoad: [AuthorizedGuard],
        canActivate: [AuthorizedGuard],
        data: { expectedRole: UserType.CoordinacionCarreras },
    },
    {
        path: UserPage.ServiciosEscolares,
        loadChildren: () =>
            import('./SE/servicios-escolares.module').then(
                (m) => m.ServiciosEscolaresModule
            ),
        canLoad: [AuthorizedGuard],
        canActivate: [AuthorizedGuard],
        data: {
            expectedRole: UserType.ServiciosEscolares,
            cierreRole: UserType.ServiciosEscolares,
        },
    },
    {
        path: UserPage.Vinculacion,
        loadChildren: () =>
            import('./GTV/gestion-tecnologica-y-vinculacion.module').then(
                (m) => m.VinculacionModule
            ),
        canLoad: [AuthorizedGuard],
        canActivate: [AuthorizedGuard],
        data: { expectedRole: UserType.Vinculacion },
    },
    {
        path: UserPage.RecursosHumanos,
        loadChildren: () =>
            import('./RH/recursos-humanos.module').then(
                (m) => m.RecursosHumanosModule
            ),
        canLoad: [AuthorizedGuard],
        canActivate: [AuthorizedGuard],
        data: { expectedRole: UserType.RecursosHumanos },
    },
    {
        path: UserPage.RecursosFinancieros,
        loadChildren: () =>
            import('./RF/recursos-financieros.module').then(
                (m) => m.RecursosFinacierosModule
            ),
        canLoad: [AuthorizedGuard],
        canActivate: [AuthorizedGuard],
        data: { expectedRole: UserType.RecursosFinancieros },
    },
    {
        path: UserPage.Idiomas,
        loadChildren: () => import('./IDI/idi.module').then((m) => m.IDIModule),
        canLoad: [AuthorizedGuard],
        canActivate: [AuthorizedGuard],
        data: { expectedRole: UserType.Idiomas },
    },
    {
        path: UserPage.Aspirante,
        loadChildren: () =>
            import('./Aspirante/aspirante.module').then(
                (m) => m.AspiranteModule
            ),
        canLoad: [AuthorizedGuard],
        canActivate: [AuthorizedGuard],
        data: { expectedRole: UserType.Aspirante },
    },
    {
        path: UserPage.Extraescolares,
        loadChildren: () =>
            import('./EXT/actividades-extraescolares.module').then(
                (m) => m.ActividadesExtraescolaresModule
            ),
        canLoad: [AuthorizedGuard],
        canActivate: [AuthorizedGuard],
        data: { expectedRole: UserType.Extraescolares },
    },
    {
        path: UserPage.Planeacion,
        loadChildren: () =>
            import('./PLAN/planeacion.module').then((m) => m.PlaneacionModule),
        canLoad: [AuthorizedGuard],
        canActivate: [AuthorizedGuard],
        data: { expectedRole: UserType.Planeacion },
    },
    {
        path: UserPage.Docente,
        loadChildren: () =>
            import('./DOC/docentes.module').then((m) => m.DocentesModule),
        canLoad: [AuthorizedGuard],
        canActivate: [AuthorizedGuard],
        data: { expectedRole: UserType.Docente },
    },
    {
        path: UserPage.Secretaria,
        loadChildren: () =>
            import('./SEC/secretarias.module').then((m) => m.SecretariasModule),
        canLoad: [AuthorizedGuard],
        canActivate: [AuthorizedGuard],
        data: { expectedRole: UserType.Secretaria },
    },
    {
        path: UserPage.Consultas,
        loadChildren: () =>
            import('./CONS/consulta.module').then((m) => m.ConsultaModule),
        canLoad: [AuthorizedGuard],
        canActivate: [AuthorizedGuard],
        data: { expectedRole: UserType.Consultas },
    },
    {
        path: '**',
        component: NotFoundComponent,
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule],
})
export class AppRoutingModule { }
